/* eslint-disable no-console */
import { useEffect, useState } from 'react';

import { useAuth } from '../../../hooks/useAuth';
import { changeNotifications } from '../../../operations/users';
import {
  SectionTitle,
  SectionDescription,
  ToggleRow,
  ToggleLabel,
  ToggleDescription,
  ToggleSwitch,
} from '../Profile/styles';

export type NotificationValues = {
  is_activated: boolean;
};

export const Notifications = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { user, setUser } = useAuth();
  const [notifications, setNotifications] = useState(false);

  useEffect(() => {
    if (user) {
      setNotifications(user.notifications || false);
    }
  }, [user]);

  async function handleToggleNotifications() {
    setIsLoading(true);
    const newValue = !notifications;

    try {
      await changeNotifications({ is_activated: newValue });
      setNotifications(newValue);
      setUser((userInState) => ({
        ...userInState,
        notifications: newValue,
      }));
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <SectionTitle>Notificações</SectionTitle>
      <SectionDescription>
        Configure como deseja receber atualizações.
      </SectionDescription>

      <ToggleRow>
        <div>
          <ToggleLabel>Notificações por e-mail</ToggleLabel>
          <ToggleDescription>
            Receba alertas sobre novos documentos e obrigações
          </ToggleDescription>
        </div>
        <ToggleSwitch
          $isActive={notifications}
          onClick={handleToggleNotifications}
          disabled={isLoading}
        >
          <span />
        </ToggleSwitch>
      </ToggleRow>
    </>
  );
};
